<template>
  <div class="news" id="news">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.describe}}</div>
<!--          <el-button class="btn animation">查看更多</el-button>-->
        </div>
      </div>
      <div class="step2" data-step="b">
          <div class="development-content" >
            <div class="fnt-32-bold animationToBottom">
              {{historyList[0].title}}
            </div>
            <div v-show="show1">
              <div class="development-content-child" :class="[loaded ? 'gradient-wrapper' : '']">
                <img src="../../../static/images/aboutUs/developmentHistory/process.png"/>
                <ul class="development-content-child-content">
                  <li v-for="(item, index) in historyList" :key="index">
                    <div class="time">{{item.year}}</div>
                    <div class="description">
                      <div>{{item.describe1}}</div>
                      <div>{{item.describe2}}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
      </div>
      <div class="step3" data-step="c">
        <footer-item class="animation"></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
// const loaded = ref(false)
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      loaded: false,
      dataList: [],
      historyList: [],
      textData: {}
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    }
  },
  created: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page501.g501[4]
      this.historyList = [...this.$boss.page512.g512].reverse()
    }
    this.loaded = true
  }
}
</script>
<style scoped lang="less">
  @keyframes wrapper-gradient {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  @keyframes img-gradient {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  .gradient-wrapper {
    display: inline-block;
    overflow: hidden;
    animation: wrapper-gradient 2s linear;
  }
  .gradient-wrapper>img, .gradient-wrapper>ul{
    animation: img-gradient 2s linear;
  }
.news{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  div{
    //一级标题
    .first-level-title{
      font-size: 42px;
      font-weight: 500;
      color:#323232;
    }
    //背景图宽度保持不变类
    .bg-img-maintain{
      background-size: cover !important;
      background-position: center !important;
    }
    .head{
      display: flex;
      flex-direction: column;
      align-items: baseline;
      height: 71vh;
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        font-size: 52px;
        opacity: 0;
        margin-top: -45vh;
        font-weight: bold;
        color: #fff;
        padding-left: 100px;
      }

      .content {
        padding-left: 100px;
        font-size: 32px;
        opacity: 0;
        margin-top: 40px;
        color: #E6E9F3;
      }
      .el-button {
        width: 200px;
        height: 60px;
        margin-top: 100px;
        color: #E6E9F3;
        background-color: transparent;
        border: 1px solid #E6E9F3;
        font-size: 18px;
      }
    }
    .development-content {
      min-height: 900px;
      width: 100%;
      background: url("../../../static/images/aboutUs/developmentHistory/bg.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      &-child{
        width: 100%;
        display: flex;
        /*position: absolute;*/
        /*flex-wrap: wrap;*/
        /*justify-content: space-between;*/
        img {
          margin: 100px 0;
          height: 75vh;
          min-height: 701px;
          max-width: calc(100% - 100px);
        }
        &-content {
          position: absolute;
          display: flex;
          justify-content: space-between;
          margin: 100px 0;
          height: 75vh;
          min-height: 701px;
          width: calc(100% - 100px);
          li {
            width: 200px;
            height: 120px;
            list-style-type: none;
            text-align: left;
            padding: 0 30px;
            background: url('../../../static/images/aboutUs/developmentHistory/icon.png') left no-repeat;
            .time {
              font-size: 24px;
              color: #0070ff;
              font-weight: bold;
            }
            .description {
              padding-top: 10px;
              font-size: 16px;
              color: #323232;
            }
          }
          li:nth-child(1) {
            position: absolute;
            left: 5%;
            top: 70%;
          }
          li:nth-child(2) {
            position: absolute;
            left: 25%;
            top: 90%;
          }
          li:nth-child(3) {
            position: absolute;
            left: 40%;
            top: 35%;
          }
          li:nth-child(4) {
            position: absolute;
            left: 50%;
            top: 70%;
          }
          li:nth-child(5) {
            position: absolute;
            left: 65%;
            top: 50%;
          }
          li:nth-child(6) {
            position: absolute;
            left: 75%;
            top: 5%;
          }
          li:nth-child(7) {
            position: absolute;
            left: 85%;
            top: 35%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/developmentHistory/index.vue